import { ENDPOINTS, TASK_TYPES } from 'features/daily-plan/constants';
import { COMPANY_TAB_IDS } from 'features/inventory-profiles/constants';
import { SECONDARY_API_CLIENT } from 'services/API';
import { formatSalesResponse, SALES_COLUMNS } from 'UI/components/organisms/inventoryProfiles';
import { formatAssociatedCompaniesResponse } from 'UI/components/organisms/inventoryProfiles/AssociatedCompaniesTab/AssociatedCompanies.utils';
import { VirtualProps as AssociatedCompaniesVirtualProps } from 'UI/components/organisms/inventoryProfiles/AssociatedCompaniesTab/associatedCompaniesColumns';
import { TAB_INCLUDES } from 'UI/components/organisms/inventoryProfiles/AssociatedCompaniesTab/AssociatedCompaniesTab';
import { EmployeesVirtualProps } from 'UI/components/organisms/inventoryProfiles/EmployeesTab/columns';
import {
  feeAgreementColumns,
  feeAgreementVirtualProps
} from 'UI/components/organisms/inventoryProfiles/FeeAgreementTab/columns';
import {
  hiringAuthorityColumns,
  HiringAuthorityVirtualProps
} from 'UI/components/organisms/inventoryProfiles/HiringAuthorityTab/columns';
import { VirtualProps as jobOrderVirtualProps } from 'UI/components/organisms/inventoryProfiles/JobOrdersTab/candidatesJOcolumns';
import { companyProfileJobOrderColumns } from 'UI/components/organisms/inventoryProfiles/JobOrdersTab/companiesJOcolumns';
import {
  companyProfilePlacementColumns,
  IncludesByMode
} from 'UI/components/organisms/inventoryProfiles/PlacementsTab/columns';
import {
  handleEmployeesResponse,
  handleHiringAuthorityResponse
} from 'UI/components/organisms/inventoryProfiles/responseChange';
import {
  COMPANY_PROFILE_SENDOUTS_COLUMNS,
  SENDOUTS_RENDERERS,
  SENDOUTS_VIRTUAL_PROPS
} from 'UI/components/organisms/inventoryProfiles/SendoutsTab/columns';
import { ProfileTablesPreferenceKeys } from 'UI/components/organisms/inventoryProfiles/tabKeys';
import {
  formatTasksResponse,
  TASK_COLUMNS,
  TASKS_EXTRA_RENDERERS
} from 'UI/components/organisms/inventoryProfiles/TasksTab';
import { EnvApiUrls } from 'UI/constants/defaults';
import { Endpoints } from 'UI/constants/endpoints';
import { ENTITY_TYPE_ID_MAP, EntityType } from 'UI/constants/entityTypes';

export const CompanyTabsConfig = {
  [COMPANY_TAB_IDS.JobOrders]: {
    endpoint: Endpoints.JobOrders,
    tablePreferencesKey: ProfileTablesPreferenceKeys.CompanyJobOrders,
    DataTableProps: {
      includes:
        'specialty,position,address,whiteSheet,hiringAuthorities,status,vRecruiter,lastActivityLog,keywordTags',
      apiVersion: 2,
      virtualProps: jobOrderVirtualProps,
      orderByOptions: { column: 'created_at', direction: 'desc' }
    },
    initialColumns: companyProfileJobOrderColumns
  },
  [COMPANY_TAB_IDS.Sendouts]: {
    endpoint: Endpoints.Sendouts,
    tablePreferencesKey: ProfileTablesPreferenceKeys.CompanySendouts,
    extraRenderers: SENDOUTS_RENDERERS,
    DataTableProps: {
      apiVersion: 1,
      includes: 'type,status,candidate,jobOrder,candidateAccountable,jobOrderAccountable',
      virtualProps: SENDOUTS_VIRTUAL_PROPS
    },
    initialColumns: COMPANY_PROFILE_SENDOUTS_COLUMNS
  },
  [COMPANY_TAB_IDS.Placements]: {
    endpoint: Endpoints.Placements,
    tablePreferencesKey: ProfileTablesPreferenceKeys.CompanyPlacements,
    DataTableProps: {
      apiVersion: 1,
      includes: IncludesByMode.company
    },
    initialColumns: companyProfilePlacementColumns
  },
  [COMPANY_TAB_IDS.FeeAgreements]: {
    endpoint: Endpoints.FeeAgreement,
    tablePreferencesKey: ProfileTablesPreferenceKeys.CompanyFeeAgreements,
    DataTableProps: {
      includes:
        'feeAgreementStatus,hiringAuthority,creator,paymentScheme,hiringAuthority,vRegional,vCreator,vCoach,vProductionDirector',
      apiVersion: 2,
      virtualProps: feeAgreementVirtualProps
    },
    initialColumns: feeAgreementColumns
  },
  [COMPANY_TAB_IDS.HiringAuthorities]: {
    endpoint: Endpoints.HiringAuthorities,
    tablePreferencesKey: ProfileTablesPreferenceKeys.CompanyHiringAuthorities,
    DataTableProps: {
      apiVersion: 2,
      virtualProps: HiringAuthorityVirtualProps,
      includes: 'lastActivityLog,specialty,subspecialty,position,phones,status,subStatus',
      formatResponse: handleHiringAuthorityResponse
    },
    initialColumns: hiringAuthorityColumns
  },
  [COMPANY_TAB_IDS.AssociatedCompanies]: {
    endpoint: Endpoints.AssociatedCompanies,
    tablePreferencesKey: ProfileTablesPreferenceKeys.CompanyAssocietedCompanies,
    DataTableProps: {
      apiVersion: 2,
      virtualProps: AssociatedCompaniesVirtualProps,
      includes: TAB_INCLUDES.company,
      formatResponse: formatAssociatedCompaniesResponse
    }
  },
  [COMPANY_TAB_IDS.Employees]: {
    endpoint: Endpoints.Employees,
    tablePreferencesKey: ProfileTablesPreferenceKeys.CompanyEmployees,
    DataTableProps: {
      virtualProps: EmployeesVirtualProps,
      formatResponse: handleEmployeesResponse,
      includes: 'keywordTags'
    }
  },
  [COMPANY_TAB_IDS.ActionPlan]: {
    allowedTaskTypes: [TASK_TYPES.marketCandidate, TASK_TYPES.other],
    DataTableProps: {
      apiVersion: 1,
      endpoint: ENDPOINTS.tasks,
      formatResponse: formatTasksResponse
    },
    entityType: EntityType.Company,
    entityTypeId: ENTITY_TYPE_ID_MAP.company,
    extraRenderers: TASKS_EXTRA_RENDERERS,
    initialColumns: TASK_COLUMNS,
    tablePreferencesKey: ProfileTablesPreferenceKeys.CompanyTasks
  },
  [COMPANY_TAB_IDS.Sales]: {
    tablePreferencesKey: ProfileTablesPreferenceKeys.CompanySales,
    DataTableProps: {
      endpoint: `${EnvApiUrls.API_URL_AWS}/${Endpoints.CompanySales}`,
      apiInstance: SECONDARY_API_CLIENT,
      formatResponse: formatSalesResponse
    },
    initialColumns: SALES_COLUMNS
  }
};
